export enum ExceptionTypes {
  System = 'system',
  Validation = 'validation',
  General = 'general',
  Auth = 'auth',
  PlanPermission = 'plan-permission',
}
